import React from "react";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";

const RiseUp = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => {
  return (
    <Svg
      width={width}
      height={height}
      {...props}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 24 24"
    >
      <G clipPath="url(#a)">
        <Path
          d="M6.675 9.325a.891.891 0 0 0-.262.688.975.975 0 0 0 .287.687.948.948 0 0 0 .7.275.948.948 0 0 0 .7-.275l.9-.9v3.225c0 .283.096.517.288.7A.99.99 0 0 0 10 14a.97.97 0 0 0 .713-.287A.97.97 0 0 0 11 13V9.8l.925.925a.894.894 0 0 0 .688.263.979.979 0 0 0 .687-.288.948.948 0 0 0 .275-.7.948.948 0 0 0-.275-.7l-2.6-2.6a.96.96 0 0 0-.7-.3c-.267 0-.5.1-.7.3L6.675 9.325ZM0 10c0-1.383.263-2.683.788-3.9a10.092 10.092 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.732 9.732 0 0 1 10 0c1.383 0 2.683.263 3.9.788a10.091 10.091 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.138 3.175A9.742 9.742 0 0 1 20 10a9.743 9.743 0 0 1-.787 3.9 10.105 10.105 0 0 1-2.138 3.175c-.9.9-1.958 1.612-3.175 2.137A9.733 9.733 0 0 1 10 20a9.733 9.733 0 0 1-3.9-.788 10.092 10.092 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.732 9.732 0 0 1 0 10Zm2 0c0 2.217.779 4.104 2.337 5.663C5.896 17.221 7.783 18 10 18s4.104-.779 5.663-2.337C17.221 14.104 18 12.217 18 10s-.779-4.104-2.337-5.662C14.104 2.779 12.217 2 10 2s-4.104.78-5.663 2.338C2.779 5.896 2 7.783 2 10Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h20v20H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default RiseUp;
